import { Link } from 'react-router-dom';
import { trendingComics } from '@/mocks/home';

export default function TrendingSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-2">最受欢迎的漫画作品，大家都在看</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {trendingComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.title === '斗破苍穹' ? 'doupo-cangqiong' : comic.title === '一人之下' ? 'yirenzhixia' : 'manhua-trend-2026'}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 下拉式漫画阅读推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-white text-xs font-medium bg-primary-500 px-2 py-1 rounded-md whitespace-nowrap">
                    {comic.updateTo}
                  </span>
                </div>
                {comic.isHot && (
                  <span className="absolute top-2 left-2 bg-primary-500 text-white text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap">HOT</span>
                )}
                {comic.isNew && (
                  <span className="absolute top-2 left-2 bg-accent-500 text-white text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap">NEW</span>
                )}
                <div className="absolute top-2 right-2 bg-black/60 text-accent-400 text-[10px] px-1.5 py-0.5 rounded flex items-center gap-0.5 whitespace-nowrap">
                  <i className="ri-star-fill text-[8px]"></i> {comic.rating}
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{comic.title}</h3>
              <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                <span>{comic.author}</span>
                <span className="text-foreground-300">|</span>
                <span>{comic.category}</span>
              </div>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.views} 阅读</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}